import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-262cb8ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal is-active" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "modal-card"
}
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = { class: "modal-card-title is-title-shrink" }
const _hoisted_6 = { class: "search-area" }
const _hoisted_7 = { class: "mt-4 is-flex is-justify-content-space-evenly is-align-items-center custom-search-bar" }
const _hoisted_8 = { class: "search-bar-container" }
const _hoisted_9 = { class: "control has-icons-left custom-search-bar" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "icon is-small is-left" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-flex is-justify-content-space-evenly is-align-items-center mt-3" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container is-fluid custom-heavy-line-separator" }, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "notification is-light is-danger"
}
const _hoisted_15 = {
  key: 1,
  class: "custom-card is-flex-direction-column is-align-items-center is-justify-content-space-between"
}
const _hoisted_16 = { class: "is-clickable py-2" }
const _hoisted_17 = {
  key: 2,
  class: "is-flex is-align-items-center is-justify-content-center"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "modal-card-foot is-justify-content-flex-end" }, null, -1))
const _hoisted_19 = { class: "modal-card-head" }
const _hoisted_20 = {
  key: 0,
  class: "is-flex is-flex-shrink-0"
}
const _hoisted_21 = { class: "icon has-text-white" }
const _hoisted_22 = { class: "modal-card-title is-title-shrink" }
const _hoisted_23 = { class: "modal-card-body" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "transaction-list-separator" }, null, -1))
const _hoisted_26 = { class: "frame3-sub-title mt-3 mb-3" }
const _hoisted_27 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 0,
  class: "icon"
}
const _hoisted_30 = {
  key: 1,
  class: "icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_RecipientItem = _resolveComponent("RecipientItem")!
  const _component_loading = _resolveComponent("loading")!
  const _component_MoneyTransaction = _resolveComponent("MoneyTransaction")!
  const _component_TransactionItem = _resolveComponent("TransactionItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.$modal.step.value == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("header", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$gettext("Send money")) + " - 1/2 ", 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.recipientsSearchString) = $event)),
                    onInput: _cache[2] || (_cache[2] = 
                    (e) => {
                      ;(_ctx.recipientsSearchString = e.target.value),
                        _ctx.recipientsSearchString.length === 0 ||
                        _ctx.recipientsSearchString.length >= 3
                          ? _ctx.recipientBatchLoader.newGen(_ctx.recipientsSearchString)
                          : null
                    }
                  ),
                    class: "input",
                    type: "text",
                    placeholder: _ctx.$gettext('Name, email address or phone number'),
                    ref: "searchRecipient"
                  }, null, 40, _hoisted_10), [
                    [_vModelText, _ctx.recipientsSearchString]
                  ]),
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_fa_icon, { icon: "search" })
                  ])
                ])
              ]),
              _createElementVNode("span", {
                class: "icon is-small",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.startScan && _ctx.startScan(...args)))
              }, [
                _createVNode(_component_fa_icon, {
                  class: "qrcode-icon",
                  icon: "qrcode"
                })
              ])
            ]),
            _hoisted_12,
            _hoisted_13
          ]),
          _createElementVNode("section", {
            class: "modal-card-body",
            ref: "recipientsContainer",
            onScroll: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.recipientBatchLoader.getNextElements && _ctx.recipientBatchLoader.getNextElements(...args)))
          }, [
            (_ctx.recipientsSearchError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$gettext(
                "An unexpected issue occurred while performing recipient lookup. " +
                  "We apologise for the inconvenience."
              )), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (_ctx.ownCurrenciesRecipients)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.ownCurrenciesRecipients, (recipient, index) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (_openBlock(), _createBlock(_component_RecipientItem, {
                            recipient: recipient,
                            key: index,
                            onMousedown: _withModifiers(($event: any) => (
                    "// on some android, input gets a change event"
                  ), ["prevent"]),
                            onSelect: ($event: any) => (_ctx.handleClickRecipient(recipient))
                          }, null, 8, ["recipient", "onMousedown", "onSelect"]))
                        ]))
                      }), 256))
                    : _createCommentVNode("", true),
                  (_ctx.recipientBatchLoader.isNewBatchLoading.value)
                    ? (_openBlock(), _createBlock(_component_loading, {
                        key: 1,
                        active: _ctx.recipientBatchLoader.isNewBatchLoading.value,
                        "onUpdate:active": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.recipientBatchLoader.isNewBatchLoading.value) = $event)),
                        "can-cancel": false,
                        "is-full-page": false,
                        width: 30,
                        height: 30,
                        class: "loader-container"
                      }, null, 8, ["active"]))
                    : _createCommentVNode("", true),
                  (
                _ctx.recipientBatchLoader.hasNoMoreElements.value &&
                _ctx.ownCurrenciesRecipients.length === 0
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$gettext("No recipients found")), 1))
                    : _createCommentVNode("", true)
                ]))
          ], 544),
          _hoisted_18
        ]))
      : _createCommentVNode("", true),
    (_ctx.$modal.step.value == 2 && _ctx.selectedRecipient)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "modal-card",
          tabindex: "0",
          onKeyup: _cache[13] || (_cache[13] = _withKeys(($event: any) => (_ctx.isReady ? _ctx.sendTransaction() : null), ["enter"]))
        }, [
          _createElementVNode("header", _hoisted_19, [
            (!_ctx.transactionType)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                  _createElementVNode("a", {
                    class: "mr-3 is-flex",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$modal.back(), _ctx.setFocus('searchRecipient')))
                  }, [
                    _createElementVNode("span", _hoisted_21, [
                      _createVNode(_component_fa_icon, {
                        icon: "arrow-left",
                        class: "fa-lg"
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.transactionType === "reconversion"
                ? _ctx.$gettext("Money reconversion")
                : _ctx.$gettext("Send money") + " - 2/2"), 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.close()))
            })
          ]),
          _createElementVNode("section", _hoisted_23, [
            _createVNode(_component_MoneyTransaction, {
              directionTransfer: "send",
              account: _ctx.ownSelectedAccount,
              selectedRecipient: _ctx.selectedRecipient,
              config: _ctx.config,
              parentErrors: _ctx.errors,
              transactionType: _ctx.transactionType,
              "onUpdate:amount": _cache[8] || (_cache[8] = (x) => ((_ctx.amount = x), _ctx.checkTransaction(true))),
              "onUpdate:senderMemo": _cache[9] || (_cache[9] = (x) => (_ctx.senderMemo = x)),
              "onUpdate:recipientMemo": _cache[10] || (_cache[10] = (x) => (_ctx.recipientMemo = x)),
              "onUpdate:isValid": _ctx.checkTransaction,
              onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.errors = false))
            }, null, 8, ["account", "selectedRecipient", "config", "parentErrors", "transactionType", "onUpdate:isValid"]),
            (_ctx.plannedTransactions.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("h2", _hoisted_26, _toDisplayString(this.$gettext(
                  "Payment will be done in %{nbTransactions} transactions:",
                  { nbTransactions: _ctx.plannedTransactions.length }
                )), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plannedTransactions, (transaction) => {
                    return (_openBlock(), _createBlock(_component_TransactionItem, {
                      key: transaction,
                      transaction: transaction,
                      mode: "small"
                    }, null, 8, ["transaction"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("footer", _hoisted_27, [
            _createElementVNode("button", {
              class: "button custom-button-modal has-text-weight-medium",
              id: "send-money-button",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sendTransaction())),
              disabled: !_ctx.isReady
            }, [
              (_ctx.checkOngoing > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                    _createVNode(_component_fa_icon, {
                      icon: "arrows-rotate",
                      class: "fa-lg refreshing"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_30, [
                    _createVNode(_component_fa_icon, {
                      icon: "arrow-circle-up",
                      class: "fa-lg"
                    })
                  ])),
              _createElementVNode("span", null, _toDisplayString(_ctx.transactionType === "reconversion"
                  ? _ctx.$gettext("Reconversion")
                  : _ctx.$gettext("Send")), 1)
            ], 8, _hoisted_28)
          ])
        ], 32))
      : _createCommentVNode("", true)
  ]))
}